import { Button } from '@/components/Button/Button';

import type { QuestionActionScope } from './questionTypes';
import styles from './QuestionSelectionToolbar.module.css';

interface QuestionSelectionToolbarProps {
  deleteDisabled?: boolean;
  deleteDisabledReason?: string;
  disabled?: boolean;
  onCancel(): void;
  onCopy(): void;
  onDelete(): void;
  scope: QuestionActionScope;
  selectedCount: number;
}

function getScopeLabel(scope: QuestionActionScope) {
  return scope === 'preLecture' ? 'pre-lecture' : 'homework';
}

export function QuestionSelectionToolbar({
  deleteDisabled = false,
  deleteDisabledReason,
  disabled = false,
  onCancel,
  onCopy,
  onDelete,
  scope,
  selectedCount,
}: QuestionSelectionToolbarProps) {
  const label =
    selectedCount === 1
      ? `1 ${getScopeLabel(scope)} question selected`
      : `${selectedCount} ${getScopeLabel(scope)} questions selected`;

  return (
    <div className={styles.toolbar} role="group" aria-label="Selected questions">
      <p aria-live="polite" className={styles.count}>
        {label}
      </p>
      <div className={styles.actions}>
        <Button onClick={onCancel} size="small" variant="secondary">
          Cancel
        </Button>
        <Button
          disabled={disabled || selectedCount === 0}
          onClick={onCopy}
          size="small"
          variant="secondary"
        >
          Copy
        </Button>
        <Button
          destructive
          disabled={disabled || deleteDisabled || selectedCount === 0}
          onClick={onDelete}
          size="small"
          title={deleteDisabled ? deleteDisabledReason : undefined}
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
